/** @jsxRuntime classic */
/** @jsx jsx */

import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { css, jsx } from '@emotion/react';
import { IWeeklyDraggableProps } from '../../types';
import { useMiddlewareContext } from '../../hooks/useMiddlewareContext';
import { ResourceNameTypeEnum } from '../../../types/enums';

const draggableHandlerCss = css`
	position: relative;
	height: 16px;
	width: 4px;
	cursor: grab;
	border-radius: 3px 0 0 0;
	top: -18px;

	&:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const draggableContainerCss = css`
	height: 18px;
	overflow: hidden;
`;

export const WeeklyDraggable: React.FC<IWeeklyDraggableProps> = ({ id, state, parentId, children }) => {
	const elementId: string = `draggable-${id}`;

	const { options } = useMiddlewareContext();

	let isEditable: boolean = state.isDraft
		? false
		: ResourceNameTypeEnum.RESERVATION === state?.event?.parentType &&
			(String(state.resourceId) === String(parentId) || !state.parentSlotId);

	isEditable &&= Boolean(options.draggingOptions?.[state.event?.parentType as ResourceNameTypeEnum]);

	const { setNodeRef, listeners, attributes } = useDraggable({
		id: String(id),
		data: {
			parentId: parentId,
			event: state,
			weeklyView: true,
		},
	});

	if (options.dragAndDrop && isEditable) {
		return (
			<div id={elementId} ref={setNodeRef} css={draggableContainerCss}>
				{children}
				<div {...attributes} {...listeners} css={draggableHandlerCss} />
			</div>
		);
	} else {
		return <div id={elementId}>{children}</div>;
	}
};
